import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "./firebase";

import Header from "./component/Header.jsx";
import Sidebar from "./component/sidebar";
import Loader from "./component/loader.jsx";

import Dashboard from "./pages/Dashboard.jsx";
import Auth from "./pages/Auth/Auth.jsx";

import StudentList from "./pages/Student/studentlist";
import StudentForm from "./pages/Student/studentform";

import Category from "./pages/Course/category/Category.jsx";

import AddCourseForm from "./pages/Course/AddCourseForm";
import Course from "./pages/Course/Course.jsx";
import CourseContent from "./pages/Course/CourseContent";
import Contents from "./pages/Course/content.jsx";

import ApprovalDashboard from "./pages/Actions/Approvals";
import ProgressTracker from "./pages/Actions/ProgressTracker.jsx";
import AssignCourse from "./pages/Actions/AssignCourse.jsx";

import Responce from "./pages/Course/responces.jsx";
import StudentContentForm from './pages/Course/editcontent.jsx';
import DaySetting from './pages/Course/daysetting';

import Registered_student from './pages/student_ragistration_form/registered.jsx'

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth(app);
    
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // Only update state if this is the current user's session change
      // Not when other users are created/deleted in Firebase
      if (user) {
        // User is signed in
        setUser(user);
      } else {
        // User is signed out
        setUser(null);
      }
      
      // Set loading to false after first auth state check
      if (!isInitialized) {
        setLoading(false);
        setIsInitialized(true);
      }
    });

    // Handle /admin path
    if (window.location.pathname === '/admin') {
      navigate('/authentication');
    }

    return () => unsubscribe();
  }, [navigate, isInitialized]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-light min-vh-100 d-flex">
      {user ? (
        <>
          <Sidebar />
          <div className="flex-grow-1 d-flex flex-column" style={{height: '100vh'}}>
            <Header />
            <main className="flex-grow-1 p-3 overflow-auto">
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/students" element={<StudentList />} />
                <Route path="/students/new" element={<StudentForm />} />
                <Route path="/students/edit/:id" element={<StudentForm />} />
                <Route path="/categories" element={<Category />} />
                <Route path="/course" element={<Course />} />
                <Route path="/coursecontent" element={<CourseContent />} />
                <Route path="/content" element={<Contents />} />
                <Route path="/editcontent" element={<StudentContentForm />} />
                <Route path="/approvals" element={<ApprovalDashboard />} />
                <Route path="/progress" element={<ProgressTracker />} />
                <Route path="/assigncourses" element={<AssignCourse />} />
                <Route path="/courses/add" element={<AddCourseForm />} />
                <Route path="/courses/edit/:id" element={<AddCourseForm />} />
                <Route path="/responce" element={<Responce />} />
                <Route path="/daysetting" element={<DaySetting />} />
                <Route path="/loader" element={<Loader />} />
                <Route path="/registered" element={<Registered_student />} />
              </Routes>
            </main>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/authentication" element={<Auth />} />
          <Route path="*" element={<Navigate to="/authentication" replace />} />
        </Routes>
      )}
    </div>
  );
};

export default App;